// Shared blog pagination rules.
//
// CommonJS on purpose: nuxt.config.js (sitemap generation) and the Express
// endpoint in api/blog/v1.js both need these values, and neither can import an
// ES module. Webpack resolves the named imports for the Vue components.
//
// Page size drives crawl depth. At 24 per page the 126 posts fit in 6 pages,
// and because the pagination control links every page number rather than just
// prev/next, every post stays within two clicks of /blog. Raising this reduces
// pages but lengthens them; lowering it pushes posts deeper.
const POSTS_PER_PAGE = 24

// Path-based rather than `?page=2` on purpose: getCanonicalUrl() in
// helpers/seo.js strips every query parameter, so a `?page=` scheme would
// canonicalise /blog?page=2 down to /blog — which is exactly the
// "canonicalise page 2 to page 1" mistake that makes Google discount
// everything linked from the later pages.
function blogPagePath(page) {
  const pageNumber = Number(page)
  return !pageNumber || pageNumber <= 1 ? '/blog' : `/blog/page/${pageNumber}`
}

function totalBlogPages(totalPosts, perPage = POSTS_PER_PAGE) {
  if (!totalPosts || totalPosts < 1) {
    return 1
  }
  return Math.ceil(totalPosts / perPage)
}

// Fewest posts a tag needs before it gets its own hub page. Thin hubs are a
// liability rather than a win: a page with one or two posts on it is the
// near-empty, low-value content Google already declined to index here, and it
// competes with the posts it links to. Eleven of the eighteen Ghost tags sit
// below this line today and deliberately have no page.
const MIN_HUB_POSTS = 5

function isHubTag(tag) {
  const count = tag && tag.count && tag.count.posts
  return Boolean(count) && count >= MIN_HUB_POSTS
}

// Same path-based scheme as the main listing, for the same reason: query
// parameters do not survive getCanonicalUrl().
function blogTagPath(slug, page) {
  const pageNumber = Number(page)
  const base = `/blog/tag/${slug}`
  return !pageNumber || pageNumber <= 1 ? base : `${base}/page/${pageNumber}`
}

module.exports = {
  POSTS_PER_PAGE,
  MIN_HUB_POSTS,
  blogPagePath,
  blogTagPath,
  isHubTag,
  totalBlogPages,
}
